// extracted by css-extract-rspack-plugin
export default {"list-container":"fIKXxk","listContainer":"fIKXxk"};